export default function TitleBox({ title, text }: { title: string; text: string | React.ReactNode }) {
    return (
        <div className="relative border border-[rgba(221,221,221,0.6)] text-center bg-[rgba(255,255,255,0.8)]">
            <span
                className="absolute left-[-1px] top-[-1px] w-[13px] h-[13px] pointer-events-none
                before:content-[''] before:absolute before:left-[1px] before:top-0 before:w-[11px] before:h-[1px] before:bg-primary
                after:content-[''] after:absolute after:left-0 after:top-[1px] after:w-[1px] after:h-[11px] after:bg-primary"
            />
            <span
                className="absolute left-[-1px] bottom-[-1px] w-[13px] h-[13px] pointer-events-none
                before:content-[''] before:absolute before:left-[1px] before:bottom-0 before:w-[11px] before:h-[1px] before:bg-primary
                after:content-[''] after:absolute after:left-0 after:bottom-[1px] after:w-[1px] after:h-[11px] after:bg-primary"
            />
            <h4 className="relative py-[20px] md:py-[40px]">
                <span
                    className="absolute right-[-1px] top-[-1px] w-[13px] h-[13px] pointer-events-none
                    before:content-[''] before:absolute before:right-[1px] before:top-0 before:w-[11px] before:h-[1px] before:bg-primary
                    after:content-[''] after:absolute after:right-0 after:top-[1px] after:w-[1px] after:h-[11px] after:bg-primary"
                />
                <span
                    className="absolute right-[-1px] bottom-[-1px] w-[13px] h-[13px] pointer-events-none
                    before:content-[''] before:absolute before:right-[1px] before:bottom-0 before:w-[11px] before:h-[1px] before:bg-primary
                    after:content-[''] after:absolute after:right-0 after:bottom-[1px] after:w-[1px] after:h-[11px] after:bg-primary"
                />
                <em className="block font-['GongGothicLight'] text-[16px] text-primary pb-[12px] not-italic md:pb-5 md:text-[24px]">
                    {title}
                </em>
                <div className="block font-['GongGothicBold'] text-[32px] text-black leading-none md:text-[60px]">
                    {text}
                </div>
            </h4>
        </div>
    );
}
